
import React from 'react'
import Box from './Box'

/**
 * IconInput component.
 */

export default function IconInput({ icon: Icon, marginRight, flex, ...props }) {
  if (!Icon) throw new Error('missing icon')
  return <Box className="IconInput" marginRight={marginRight} flex={flex}>
    <Box className="icon">
      <Icon />
    </Box>
    <input className="Input" {...props} />
  </Box>
}